import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { ApiModule } from '../../shared/data-access/api.module';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import { FileReaderComponent } from './containers/file-reader/file-reader.component';
import { ControlErrorLabelComponent } from './validators/control-error-label/control-error-label';
import { OutlookFileReaderComponent } from './containers/outlook-file-reader/outlook-file-reader.component';

// AoT requires an exported function for factories
export const createTranslateLoader = (http: HttpClient): TranslateHttpLoader => {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
};

@NgModule({
  declarations: [AppComponent, FileReaderComponent, OutlookFileReaderComponent, ControlErrorLabelComponent],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    ApiModule.forRoot({ rootUrl: environment.apiGateway }),
    RouterModule.forRoot(appRoutes, {
      initialNavigation: 'enabledBlocking',
      useHash: false,
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
